import React, { useContext, useState, useRef, useEffect } from 'react'
import { navigate } from 'gatsby'

import loginImg from '../../../assets/images/modals/login-img.png'
import loginTxt from '../../../assets/images/modals/login-txt.png'


import { siteUrl } from '../../../shared/utils/siteUrl'
import useMediaQuery from '../../../utils/useMediaQuery'
import ReCAPTCHA from 'react-google-recaptcha'
import * as reCaptchaKey from './../../../shared/constants/reCaptcha'
import userSessionStorage from '../../../utils/userSessionStorage'
import { Context } from '../../../context/app-context'

import './modalLogin.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ModalLogin = props => {
  const { close, handleStartGame } = props

  const mobile = useMediaQuery()

  const [errorMessage, setErrorMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState({
    email: '',
    password: '',
  })

  const recaptchaRef = useRef(null)
  const session = new userSessionStorage()
  const { dispatch } = useContext(Context)

  const handleInputChange = event => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    })
  }

  const handleErrorMessage = message => {
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
    }, 5000)
  }

  const dispatchRedeem = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: `redemption`,
          props: {
            handleStartGame,
            close: () => {
              navigate('/')
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
          },
        },
      },
    })
  }

  const onSubmit = event => {
    event.preventDefault()
    pushEventDataLayer('Personajes :: Login', 'Click', 'ENVIAR')

    setIsLoading(true)
    session.authLogin({
      payload: {
        email: data.email ? data.email.replace(/\s+/g, '') : '',
        password: data.password,
        captcha: recaptchaRef.current.getValue(),
      },
      handleSuccess: res => {
        session.authUserInfo({
          handleSuccess: res => {
            setIsLoading(false)

            if (props.handleStartGame) {
              dispatchRedeem()
            } else {
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
              window.location.reload()

            }
          },
          handleError: res => {
            session.destroySession()
            handleErrorMessage(res.userMessage)
            setIsLoading(false)
          },
        })
      },
      handleError: res => {
        handleErrorMessage(res.userMessage)
        setIsLoading(false)
      },
      handleFinally: () => {
        recaptchaRef.current.execute()
      },
    })
  }

  useEffect(() => {
    const tokenInfo = session.getToken()
    if (tokenInfo) {
      const userInfo = session.getUserInfo()
      if (userInfo) {
        if (props.handleStartGame) {
          dispatchRedeem()
        } else {
          dispatch({
            type: 'set',
            payload: {
              modalActive: null,
            },
          })
          window.location.reload()

        }
      } else {
        session.authUserInfo({
          handleSuccess: res => {
            dispatchRedeem()
          },
          handleError: res => {
            session.destroySession()
            setIsLoading(() => false)
          },
        })
      }
    } else {
      setIsLoading(() => false)
    }
  }, [])

  return (
    <div className='f-modalLogin-container'>
      <ReCAPTCHA
        ref={recaptchaRef}
        size='invisible'
        sitekey={reCaptchaKey.key}
      />
      <div className='f-modalLogin-container__wrapper'>
        <div className='f-modalLogin-container__content'>
          <span className='f-modalLogin-container__content__close' onClick={() => close()} />
          <div className='f-modalLogin-container__content__img'>
            <figure className='f-modalLogin-container__content__img-container'>
              <img src={loginTxt} alt='Imagen ingresa tu usuario y conraseña' />
            </figure>
            <figure className='f-modalLogin-container__content__img-container'>
              <img src={loginImg} alt='personaje' />

            </figure>
          </div>
          <div className='f-modalLogin-container__content__infoLogin'>

            <form onSubmit={onSubmit}>
              <div className='f-modalLogin-container__content__infoLogin__form-group'>
                <label>Correo:</label>
                <input
                  type='email'
                  placeholder='correo@email.com'
                  id='user'
                  name='email'
                  onChange={handleInputChange}
                />
              </div>
              <div className='f-modalLogin-container__content__infoLogin__form-group'>

                <label>Contraseña:</label>
                <input
                  type='password'
                  placeholder='*********'
                  id='password'
                  name='password'
                  onChange={handleInputChange}
                />
              </div>

              <a
                href={siteUrl + '/login/recuperar/'}
                className='f-olvide'
                target='_blank'
              >
                Olvidé mi contraseña
              </a>
              {errorMessage && (
                <span className='f-errorMessage'>{errorMessage}</span>
              )}

              <div className='f-modalLogin-container__content__infoLogin__buttons'>
                <button disabled={isLoading} type={'submit'}>Enviar</button>
                <a
                  onClick={() => {
                    pushEventDataLayer('Personajes :: Login', 'Click', 'QUIERO REGISTRARME')
                  }}
                  href={siteUrl + '/registro/fecha-de-nacimiento'}
                  target='_blank'
                >
                  Quiero Registrarme
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalLogin
